export default "__VITE_ASSET__CqUzRXH9__"